import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F64E046B-8690-4ACF-90F7-98896159BB34
 * name format-header-1
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-header-1.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHeader1Icon = createSvgIcon(<><path d="M3,4H5V10H9V4H11V18H9V12H5V18H3V4M14,18V16H16V6.31L13.5,7.75V5.44L16,4H18V16H20V18H14Z" /></>, 'FormatHeader1Icon');
export default FormatHeader1Icon